import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IArticle } from '../../../prisma-xs/models/article.model';
import { PrismaXsConstant } from '../../../shared/models/prisma-xs.constant';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-configurator-catalog-prisma-xs-badge',
    templateUrl: './configurator-catalog-prisma-xsbadge.component.html',
    styleUrls: ['./configurator-catalog-prisma-xsbadge.component.scss'],
    standalone: false
})
export class ConfiguratorCatalogPrismaXSBadgeComponent {
  fieldMM = PrismaXsConstant.PRISMA_XS_FIELD_WIDTH;
  heightMM = PrismaXsConstant.PRISMA_XS_FIELD_HEIGHT;

  @Input() article: IArticle;
  @Input() searchText: string;
}
